// MODAL CASAS ETAPA 02
const tabsCasasEtapa02 = () => {
  // Casa A Piso 1
  const indicadoresC01 = document.querySelectorAll('#tabsCasasEtapa02 .piso-c-01 .indicador');
  const interaccionesCasaC01 = document.querySelectorAll('#tabsCasasEtapa02 .interacciones-c-01 .interaccion');
  const contentCasaC01 = document.querySelectorAll('#containerCasasEtapa02 .content-spec.casa-c .piso-01 .content-interaction');

  // Casa A Piso 2
  const indicadoresC02 = document.querySelectorAll('#tabsCasasEtapa02 .piso-c-02 .indicador');
  const interaccionesCasaC02 = document.querySelectorAll('#tabsCasasEtapa02 .interacciones-c-02 .interaccion');
  const contentCasaC02 = document.querySelectorAll('#containerCasasEtapa02 .content-spec.casa-c .piso-02 .content-interaction');

  // Tabs buttons by Piso
  const tabCasaCPiso01 = document.querySelector('#tipo-casa-c-01');
  const tabCasaCPiso02 = document.querySelector('#tipo-casa-c-02');
  
  // CASA A PISO 01
  indicadoresC01.forEach( (indicador) => {
    // For Desktop
    if(window.innerWidth > 767){
      indicador.addEventListener('mouseover', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaC01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC01[mouseEvent].classList.remove('d-none');

        contentCasaC01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC01[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaC01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC01[0].classList.remove('d-none');

        contentCasaC01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC01[0].classList.remove('d-none');
      });
    }


    // For Mobile
    else{
      indicador.addEventListener('click', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaC01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC01[mouseEvent].classList.remove('d-none');

        contentCasaC01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC01[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaC01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC01[0].classList.remove('d-none');

        contentCasaC01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC01[0].classList.remove('d-none');
      });
    }
  });
  tabCasaCPiso01.addEventListener('click', () => {
    contentCasaC02[0].classList.add('d-none');
    contentCasaC01[0].classList.remove('d-none');
  })

  // CASA A PISO 02
  indicadoresC02.forEach( (indicador) => {
    // For Desktop
    if(window.innerWidth > 767){
      indicador.addEventListener('mouseover', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaC02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC02[mouseEvent].classList.remove('d-none');

        contentCasaC02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC02[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaC02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC02[0].classList.remove('d-none');

        contentCasaC02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC02[0].classList.remove('d-none');
      });
    }


    // For Mobile
    else{
      indicador.addEventListener('click', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaC02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC02[mouseEvent].classList.remove('d-none');

        contentCasaC02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC02[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaC02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaC02[0].classList.remove('d-none');

        contentCasaC02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaC02[0].classList.remove('d-none');
      });
    }
  });
  tabCasaCPiso02.addEventListener('click', () => {
    contentCasaC01[0].classList.add('d-none');
    contentCasaC02[0].classList.remove('d-none');
  })

}
tabsCasasEtapa02();


// DOM SCRIPTING VIDEO TABS PROYECTO ETAPA 1
const interaccionesTabsMedia = () => {
  const tabMedia01 = document.querySelector('#etapa-02-galeria-tab');
  const tabMedia02 = document.querySelector('#etapa-02-video-tab');
  const tabMedia03 = document.querySelector('#etapa-02-recorrido-tab');
  
  const videoMedia = document.querySelectorAll('.video-tabs-media');

  tabMedia01.addEventListener('click', () => {
    for (let i = 0; i < videoMedia.length; i++) {
      videoMedia[i].pause();
    }
  });

  tabMedia02.addEventListener('click', () => {
    for (let i = 0; i < videoMedia.length; i++) {
      videoMedia[i].pause();
    }
  });

  tabMedia03.addEventListener('click', () => {
    for (let i = 0; i < videoMedia.length; i++) {
      videoMedia[i].pause();
    }
  });

}

const videoHomeInteraction01 = () => {
  const btnPreviewVideo = document.querySelector('#btn-preview-video');
  const videoHomePath = document.querySelector('#video-interaction-01');

  btnPreviewVideo.addEventListener('click', () => {
    btnPreviewVideo.classList.add('d-none');
    videoHomePath.classList.remove('d-none')

    const childVideoCount = videoHomePath.childElementCount;

    if (childVideoCount < 1) {
      const videoHome = document.createElement('VIDEO');
      const videoHomeSrc = document.createElement('SOURCE');
      const videoHomeSrcWebm = document.createElement('SOURCE');
  
      videoHome.setAttribute('controls', 'controls');
      videoHome.setAttribute('autoplay', 'autoplay');
      videoHome.classList.add('video-tabs-media');
  
      videoHomeSrc.setAttribute('src', './build/video/video_adp_etapa_2.mp4');
      videoHomeSrc.setAttribute('type', 'video/mp4');
      videoHome.appendChild(videoHomeSrc);
  
      videoHomeSrcWebm.setAttribute('src', './build/video/video_adp_etapa_2.webm');
      videoHomeSrc.setAttribute('type', 'video/webm');
      videoHome.appendChild(videoHomeSrcWebm);
      
      videoHomePath.appendChild(videoHome);
    } 
    // else {
    //   console.log('Ya esta cargado el video en el DOM');
    // }

    interaccionesTabsMedia();
  });
} 
videoHomeInteraction01();


// IMGS PATHS ETAPAS
const imgEtapa01 = '<img src="./build/img/landing/medalla-1ra-etapa.svg" alt="medalla-1ra-etapa">';
const imgEtapa02 = '<img src="./build/img/landing/medalla-2da-etapa.svg" alt="medalla-2da-etapa">';

// INFO CASAS
const casa = {
  // ETAPA 02
  'item52': {
    'titulo': '<span>Casa 52</span> - 4 habitaciones',
    'precio': 'Desde $682 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item53': {
    'titulo': '<span>Casa 53</span> - 4 habitaciones',
    'precio': 'Desde $663 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item54': {
    'titulo': '<span>Casa 54</span> - 4 habitaciones',
    'precio': 'Desde $695 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item55': {
    'titulo': '<span>Casa 55</span> - 4 habitaciones',
    'precio': 'Desde $682 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item56': {
    'titulo': '<span>Casa 56</span> - 4 habitaciones',
    'precio': 'Desde $649 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item57': {
    'titulo': '<span>Casa 57</span> - 4 habitaciones',
    'precio': 'Desde $649 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item58': {
    'titulo': '<span>Casa 58</span> - 4 habitaciones',
    'precio': 'Desde $649 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item59': {
    'titulo': '<span>Casa 59</span> - 4 habitaciones',
    'precio': 'Desde $649 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item60': {
    'titulo': '<span>Casa 60</span> - 4 habitaciones',
    'precio': 'Desde $695 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item61': {
    'titulo': '<span>Casa 61</span> - 4 habitaciones',
    'precio': 'Desde $682 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item62': {
    'titulo': '<span>Casa 62</span> - 4 habitaciones',
    'precio': 'Desde $649 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  // 'item63': {
  //   'titulo': '<span>Casa 63</span> - 4 habitaciones',
  //   'precio': 'Desde $649 millones',
  //   'imgEtapaTooltip': imgEtapa02
  // },
  // 'item64': {
  //   'titulo': '<span>Casa 64</span> - 4 habitaciones',
  //   'precio': 'Desde $649 millones',
  //   'imgEtapaTooltip': imgEtapa02
  // },
  'item65': {
    'titulo': '<span>Casa 65</span> - 4 habitaciones',
    'precio': 'Desde $649 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item66': {
    'titulo': '<span>Casa 66</span> - 4 habitaciones',
    'precio': 'Desde $695 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item67': {
    'titulo': '<span>Casa 67</span> - 4 habitaciones',
    'precio': 'Desde $682 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item68': {
    'titulo': '<span>Casa 68</span> - 4 habitaciones',
    'precio': 'Desde $663 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item69': {
    'titulo': '<span>Casa 69</span> - 4 habitaciones',
    'precio': 'Desde $663 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item70': {
    'titulo': '<span>Casa 70</span> - 4 habitaciones',
    'precio': 'Desde $663 millones',
    'imgEtapaTooltip': imgEtapa02
  },
  'item71': {
    'titulo': '<span>Casa 71</span> - 4 habitaciones',
    'precio': 'Desde $695 millones',
    'imgEtapaTooltip': imgEtapa02
  },
}


// MODAL INTERACCIONES PLANOS MOBILE
const modalPlanoMobile = () => {
  const tooltipDesktop = document.querySelector('.tooltip-modal-mobile');
  const titulo = document.querySelector('.tooltip-modal-mobile #titulo');
  const precio = document.querySelector('.tooltip-modal-mobile #precio');
  // const imgEtapaTooltip = document.querySelector('.tooltip-modal-mobile #img-etapa-tooltip');

  const indicadoresTooltips = document.querySelectorAll('.indicador-mobile');

  indicadoresTooltips.forEach((indicador) => {
    indicador.addEventListener('mouseover', (event) => {
      tooltipDesktop.classList.remove('d-none');

      const targetId = event.target.dataset.casaId;
      const tipoEtapa = event.target.dataset.etapa;

      if (tipoEtapa === "1"){
        tooltipDesktop.classList.add('tooltip-modal-mobile--negro');
      }
      else{
        tooltipDesktop.classList.add('tooltip-modal-mobile--blanco');
      }

      const getInfoCasa = casa[`item${targetId}`];
      // console.log(getInfoCasa);

      titulo.innerHTML = getInfoCasa.titulo;
      precio.innerHTML = getInfoCasa.precio;
      // imgEtapaTooltip.innerHTML = getInfoCasa.imgEtapaTooltip;
    });

    indicador.addEventListener('mouseleave', () => {
      tooltipDesktop.classList.add('d-none');
      tooltipDesktop.classList.remove('tooltip-modal-mobile--negro');
      tooltipDesktop.classList.remove('tooltip-modal-mobile--blanco');
      titulo.innerHTML = '';
      precio.innerHTML = '';
      // imgEtapaTooltip.innerHTML = '';
    });
  });
}
modalPlanoMobile();

// MODAL INTERACCIONES PLANOS DESKTOP
const modalPlanoDesktop = () => {
  const tooltipDesktop = document.querySelector('.tooltip-modal-desktop');
  const titulo = document.querySelector('.tooltip-modal-desktop #titulo');
  const precio = document.querySelector('.tooltip-modal-desktop #precio');
  // const imgEtapaTooltip = document.querySelector('.tooltip-modal-desktop #img-etapa-tooltip');

  const indicadoresTooltips = document.querySelectorAll('.indicador-desktop');

  indicadoresTooltips.forEach((indicador) => {
    indicador.addEventListener('mouseover', (event) => {
      tooltipDesktop.classList.remove('d-none');

      const targetId = event.target.dataset.casaId;
      const tipoEtapa = event.target.dataset.etapa;

      if (tipoEtapa === "1"){
        tooltipDesktop.classList.add('tooltip-modal-desktop--negro');
      }
      else{
        tooltipDesktop.classList.add('tooltip-modal-desktop--blanco');
      }

      const getInfoCasa = casa[`item${targetId}`];
      // console.log(getInfoCasa);

      titulo.innerHTML = getInfoCasa.titulo;
      precio.innerHTML = getInfoCasa.precio;
      // imgEtapaTooltip.innerHTML = getInfoCasa.imgEtapaTooltip;
    });

    indicador.addEventListener('mouseleave', () => {
      tooltipDesktop.classList.add('d-none');
      tooltipDesktop.classList.remove('tooltip-modal-desktop--negro');
      tooltipDesktop.classList.remove('tooltip-modal-desktop--blanco');
      titulo.innerHTML = '';
      precio.innerHTML = '';
      // imgEtapaTooltip.innerHTML = '';
    });
  });
}
modalPlanoDesktop();